export const PACKAGE_NAME = 'jiraRouterResourcesPersonalization';
